<template>
    <div class="">
        <a-card :title="c_title">
            
            <div class="steps_left">
                <a-steps v-model="current"  direction="vertical" @change="onChange">
                    <a-step v-for="step in steps" :key="step.title" :title="step.title"/>
                </a-steps>
            </div>

            <div class="steps_right">
<!--                 
                    <p>{{currentStep.description}}</p>
                    <p>{{currentStep.opration}}</p>
                    <router-link :to="{path:currentStep.link,query: {}}">{{currentStep.linkName}}</router-link> -->
                    <sysitem v-if="currentStep.link == '/system/add'" isGuide="process"></sysitem>
                    <appitem v-if="currentStep.link == '/system/addapp'" isGuide="process"></appitem>
                    <domainitem v-if="currentStep.link == '/system/adddomainurl'" isGuide="process"></domainitem>
                    <serviceitem v-if="currentStep.link == '/servicekey/add'" isGuide="process"></serviceitem>


            </div>
            <div class="buttonBox">
                <a-button  @click="handlePrev">上一步</a-button>
                <a-button type="primary"  @click="handleNext">下一步</a-button>
            </div>
        </a-card>
    </div>
  
</template>

<script>
import sysitem from '../system/sysManager/sysitem';
import appitem from '../system/appManager/appItem';
import domainitem from '../system/domainurl/item';
import serviceitem from '../gateway/servicekey/item';


const steps = [
    {
        title:'注册系统',
        description:'新增后端或终端系统，获得对应syscode',
        opration:"",
        linkName:'立即注册',
        link:'/system/add'
    },
    {
        title:'新增应用',
        description:'新增系统所属应用 appcode',
        opration:"",
        link:'/system/addapp',
        linkName:'新建应用',
    }
    ,
    {
        title:'申请域名',
        description:'如果需要使用新的域名，请先进行域名申请，再绑定域名',
        opration:"",
        link:'/system/adddomainurl',
        linkName:'立即申请',
    },
    {
        title:'添加服务',
        description:'为应用模块添加所需服务 servicekey',
        opration:"",
        linkName:'现在添加',
        link:'/servicekey/add'
    },
    // {
    //     title:'绑定域名或服务',
    //     description:'为新建应用绑定对应域名或servicekey',
    //     opration:"在应用列表编辑需要绑定的应用即可完成域名或服务绑定",
    //     linkName:'开始绑定',
    //     link:'/system/appmanage'
    // }
]
export default {
    components:{
        sysitem,
        appitem,
        domainitem,
        serviceitem
    },
    data() {
        return {
            current:0,
            steps,
            currentStep:{},
            c_title:"系统创建引导"
        };
    },
    methods: {
     
        onChange(current) {
            this.$router.push({
                query: {
                    current:current,
                }
            });
        },
        handleStepChange(){
            this.currentStep = steps[this.current]
        },
        handleNext(){
            let max = this.steps.length;
            let need = this.current + 1;
            if(need > max){
                need = 0
            }
            this.onChange(need)
        },
        handlePrev(){
            let need = this.current - 1;
            if(need < 0){
                need = 0
            }
            this.onChange(need)
        }
    },
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
    mounted(){
        const {query} = this.$route;
        this.current = query.current ? query.current : 0;
        this.current = parseInt(this.current);
        this.currentStep = query.current ? steps[query.current] : steps[0];
        this.handleStepChange()
    }
};
</script>

<style lang="less" scoped>
    .steps_left{
        width:200px;
        float: left;
    }

    .steps_right{
        width:calc(100% - 210px);
        margin-left: 8px;
        float: left;
        height: auto;
    }

    .buttonBox{
        width: 120px;
        float: right;
        margin-top: 20px;
    }

    
</style>
